import script from "./inovice.vue?vue&type=script&setup=true&lang=js"
export * from "./inovice.vue?vue&type=script&setup=true&lang=js"

import "./inovice.vue?vue&type=style&index=0&id=98d72ac4&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\Other\\EventMaster\\Dataleading3.0\\app\\app-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98d72ac4"]])

export default __exports__